export enum CampaignActionType {
  Accept = 'accept',
  Reject = 'reject',
  None = 'none',
}
